import { ArrowUpRight, Factory, FileText, PackageSearch, ListChecks, MapPin } from "lucide-react";
import { Reveal, Eyebrow } from "@/components/Reveal";
import { scrollToId } from "@/lib/scroll";
import { useLang } from "@/lib/i18n";

export const BuyerSupplier = () => {
  const { t } = useLang();
  return (
  <section data-testid="buyer-supplier-section" className="py-24 md:py-32 bg-surface">
    <div className="max-w-7xl mx-auto px-6 lg:px-10">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-5">
        <Reveal>
          <div
            data-testid="for-buyers-panel"
            className="relative h-full bg-midnight border border-gold/40 p-10 md:p-12 overflow-hidden group"
          >
            <span className="absolute -bottom-8 -right-4 font-display font-black text-[10rem] leading-none text-gold/5 select-none">
              B
            </span>
            <PackageSearch className="w-8 h-8 text-gold mb-6" />
            <p className="text-xs uppercase tracking-[0.25em] text-gold mb-3">{t.buysup.buyers.label}</p>
            <h3 className="text-2xl md:text-3xl font-bold tracking-tight text-[#F4F6F8] mb-4">
              {t.buysup.buyers.title}
            </h3>
            <p className="text-sm text-[#94A3B8] mb-6">{t.buysup.buyers.intro}</p>
            <ul className="space-y-3 mb-10">
              {t.buysup.buyers.items.map((item) => (
                <li key={item} className="flex items-center gap-3 text-base text-[#F4F6F8]">
                  <span className="w-1.5 h-1.5 bg-gold rotate-45 shrink-0" /> {item}
                </li>
              ))}
            </ul>
            <p className="text-sm text-[#94A3B8] mb-8">
              {t.buysup.buyers.note}
            </p>
            <button
              data-testid="buyers-submit-rfq-btn"
              onClick={() => scrollToId("rfq")}
              className="inline-flex items-center gap-2 bg-gold text-midnight font-semibold px-7 py-3.5 rounded-full hover:bg-gold-light hover:text-midnight transition-[background-color,transform] duration-200 hover:-translate-y-0.5"
            >
              {t.buysup.buyers.cta} <ArrowUpRight className="w-4 h-4" />
            </button>
          </div>
        </Reveal>

        <Reveal delay={0.1}>
          <div
            data-testid="for-suppliers-panel"
            className="relative h-full bg-surface2 border border-[#1E293B] p-10 md:p-12 overflow-hidden group hover:border-gold/40 transition-[border-color] duration-300"
          >
            <span className="absolute -bottom-8 -right-4 font-display font-black text-[10rem] leading-none text-white/5 select-none">
              S
            </span>
            <Factory className="w-8 h-8 text-gold mb-6" />
            <p className="text-xs uppercase tracking-[0.25em] text-gold mb-3">{t.buysup.suppliers.label}</p>
            <h3 className="text-2xl md:text-3xl font-bold tracking-tight text-[#F4F6F8] mb-4">
              {t.buysup.suppliers.title}
            </h3>
            <p className="text-base text-[#94A3B8] leading-relaxed mb-10 max-w-md">
              {t.buysup.suppliers.body}
            </p>
            <button
              data-testid="suppliers-become-partner-btn"
              onClick={() => scrollToId("suppliers")}
              className="inline-flex items-center gap-2 border border-white/30 text-[#F4F6F8] font-semibold px-7 py-3.5 rounded-full hover:border-gold hover:text-gold transition-[border-color,color,transform] duration-200 hover:-translate-y-0.5"
            >
              {t.buysup.suppliers.cta} <ArrowUpRight className="w-4 h-4" />
            </button>
          </div>
        </Reveal>
      </div>
    </div>
  </section>
  );
};
